export default __webpack_public_path__ + "static/media/bar_chart_green.7b5a779c.svg";